import apiClient from "./api";
const EMPLEADO_API_BASE_URL = "/empleados";
class EmpleadoService {
  getEmpleados() {
    return apiClient.get(EMPLEADO_API_BASE_URL);
  }
  getEmpleadosResponsable() {
    return apiClient.get(EMPLEADO_API_BASE_URL + "/Responsable");
  }
  agregarEmpleado(empleado) {
    return apiClient.post(EMPLEADO_API_BASE_URL, empleado);
  }
  async getEmpleadoByUser(idUsuario) {
    const response = await apiClient.get(EMPLEADO_API_BASE_URL + "/" + idUsuario);
    const empleado = response.data.empleado;
    return empleado;
  }
  async buscarEmpleados(busqueda) {
    try {
      const response = await apiClient.post(`${EMPLEADO_API_BASE_URL}/buscar`, { busqueda });
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }
  updateEmpleado(empleado, empleadoId) {
    return apiClient.put(EMPLEADO_API_BASE_URL + "/" + empleadoId, empleado);
  }
  deleteEmpleado(empleadoId) {
    return apiClient.delete(EMPLEADO_API_BASE_URL + "/" + empleadoId);
  }

}
export default new EmpleadoService();